<div class="moodtracker">
	<div class="zk-flex zk-gap-1">
		<h3 class="moodtracker__title">
			{{ 'CONTACT.HUMOR_PAGE.TITLE' | translate }}
			{{ firstName }}
		</h3>
		<div class="zk-flex zk-items-center zk-gap-1">
			<div
				class="zk--mb-2"
				freud-tooltip
				[tooltipLabel]="'CONTACT.HUMOR_PAGE.TOOLTIP' | translate"
				tooltipPosition="top"
			>
				<span class="freud-icon freud-icon-info-circle"></span>
			</div>
		</div>
	</div>
	<div class="moodtracker__header" *ngIf="!unauthorized && !userNotPremium && !isLoading">
		<div
			class="zk-flex zk-flex-col md:zk-flex-row zk-justify-between zk-w-full"
		>
			<div>
				

				<div class="zk-flex zk-items-center">
					<span
						class="freud-icon freud-icon-shield-check zk-mr-2 zk-text-success"
					></span>
					<span class="moodtracker__subtitle"
						>{{ 'CONTACT.HUMOR_PAGE.INFO_BY' | translate }} {{ firstName }}.
						<a
							rel="”noopener”"
							target="_blank"
							href="https://hs-info.zenklub.com/faq/compartilhando-meus-registros-com-os-especialistas"
							>{{ 'CONTACT.HUMOR_PAGE.KNOW_MORE' | translate }}</a
						></span
					>
				</div>
			</div>
			<freud-select
				class="zk-mt-2 md:zk-mt-0"
				[label]="'CONTACT.FILTER_BY.PERIOD' | translate"
				[options]="periodOptions"
				(valueChange)="onChangePeriod($event)"
			></freud-select>
		</div>
		<div></div>
	</div>
	<div class="moodtracker__body zk-pb-5">
		<div *ngIf="!notFound && !unauthorized && !userNotPremium && !isLoading">
			<div
				class="
					moodtracker__reports
					zk-gap-4 zk-my-5 zk-grid-cols-1
					md:zk-grid-cols-2 md:zk-gap-10
				"
			>
				<freud-card class="moodtracker__reasons">
					<div
						class="zk-flex zk-items-center"
						freud-typography
						fontType="h6Regular1-5"
					>
						<span class="freud-icon freud-icon-mood-happy zk-mr-2"></span>
						<div>
							<span>{{ 'CONTACT.HUMOR_PAGE.DOES_WELL' | translate }} </span>
							<span>{{
								(
									'PERIODS.' + periodValue.toUpperCase() | translate
								).toLowerCase()
							}}</span>
						</div>
					</div>
					<div *ngIf="moodtrackerGoodResults.length > 0" class="zk-mt-3">
						<freud-tag
							class="zk-inline-block zk-py-2 zk-pr-2 zk-w-fit"
							*ngFor="let goodResult of moodtrackerGoodResults"
							color="success"
							[value]="goodResult"
							[outline]="true"
						></freud-tag>
					</div>
					<div *ngIf="moodtrackerGoodResults.length === 0">
						<span class="moodtracker__empty-reasons zk-block zk-mt-3">{{
							'CONTACT.HUMOR_PAGE.EMPTY_STATE_GOOD_REASONS'
								| translate: { contact: firstName }
						}}</span>
					</div>
				</freud-card>
				<freud-card class="moodtracker__reasons">
					<div
						class="zk-flex zk-items-center"
						freud-typography
						fontType="h6Regular1-5"
					>
						<span class="freud-icon freud-icon-mood-sad zk-mr-2"></span>
						<div>
							<span
								>{{ 'CONTACT.HUMOR_PAGE.DONT_DOES_WELL' | translate }}
							</span>
							<span>{{
								(
									'PERIODS.' + periodValue.toUpperCase() | translate
								).toLowerCase()
							}}</span>
						</div>
					</div>
					<div *ngIf="moodtrackerBadResults.length > 0" class="zk-mt-3">
						<freud-tag
							class="zk-inline-block zk-py-2 zk-pr-2 zk-w-fit"
							*ngFor="let badResult of moodtrackerBadResults"
							[value]="badResult"
							color="error"
							[outline]="true"
						></freud-tag>
					</div>
					<div *ngIf="moodtrackerBadResults.length === 0">
						<span class="moodtracker__empty-reasons zk-block zk-mt-3">{{
							'CONTACT.HUMOR_PAGE.EMPTY_STATE_BAD_REASONS'
								| translate: { contact: firstName }
						}}</span>
					</div>
				</freud-card>
			</div>
			<div class="moodtracker__list zk-py-4">
				<moodtracker-report-card
					class="zk-mb-4 zk-block"
					*ngFor="let moodtrackerReport of moodtrackerReportList"
					[data]="moodtrackerReport"
				></moodtracker-report-card>
			</div>
		</div>
		<div class="moodtracker__loading-state" *ngIf="isLoading">
			<freud-loader></freud-loader>
		</div>
		<div
			class="moodtracker__empty-state"
			*ngIf="(notFound || userNotPremium || unauthorized) && !isLoading"
		>
			<div class="moodtracker__not-found" *ngIf="notFound">
				<span>{{
					'CONTACT.HUMOR_PAGE.EMPTY_STATE_404'
						| translate: { contact: firstName }
				}}</span>
				<span>{{
					'CONTACT.HUMOR_PAGE.RECCOMEND_MOODTRACKER' | translate
				}}</span>
				<freud-button
					class="zk-mt-4"
					color="secondary"
					(click)="reccomendMoodtracker()"
					>{{ 'CONTACT.HUMOR_PAGE.RECCOMEND' | translate }}</freud-button
				>
			</div>
			<div class="moodtracker__unauthorized" *ngIf="unauthorized">
				<span>{{
					'CONTACT.HUMOR_PAGE.EMPTY_STATE_401'
						| translate: { contact: firstName }
				}}</span>
				<span>{{ 'CONTACT.HUMOR_PAGE.REQUEST_PERMISSION' | translate }}</span>
				<freud-button
					class="zk-mt-4"
					color="secondary"
					(click)="requestPermission()"
					>{{ 'CONTACT.HUMOR_PAGE.REQUEST' | translate }}</freud-button
				>
			</div>
			<div class="moodtracker__not-premium" *ngIf="userNotPremium">
				<span>{{ 'CONTACT.HUMOR_PAGE.BASIC_USER' | translate }}</span>

				<freud-button
					class="zk-mt-4"
					color="secondary"
					(click)="openOfficeUrl('account/premium')"
				>
					{{ 'CONTACT.HUMOR_PAGE.SEE_PLAN' | translate }}
				</freud-button>
			</div>
		</div>
	</div>
</div>
